import axios from "axios";
import config from "@core/config/env";

const API = axios.create({
  baseURL: config.apiUrl,
});

export const setAuthToken = (token) => {
  if (token) {
    API.defaults.headers.common["Authorization"] = `token ${token}`;
  } else {
    delete API.defaults.headers.common["Authorization"];
  }
};

export default API;
